export default __webpack_public_path__ + "static/cv-contact-364f178280d5a8166c24596258d70a0f.svg";